import React from "react";
import { useInputContext } from "../Input/Input.context.js";
import filteredOptionsUtil from "./filtered-options-util.js";
const NoSearchHitsMessage = () => {
    const { inputProps: { id }, } = useInputContext();
    return (React.createElement("div", { className: "navds-combobox__list-item--no-options", id: filteredOptionsUtil.getNoHitsId(id) }, "Ingen s\u00F8ketreff"));
};
export default NoSearchHitsMessage;
//# sourceMappingURL=NoSearchHitsMessage.js.map